import React from "react";

const GuidelineUpdate = () => {
  return (
    <div className="bg-white max-w-[460px] text-teal-300 ">
      <h3 className="flex bg-gray-20 font-semibold text-md-body gap-4 p-6">
        Guideline Update - April 2023 (medSask) :
      </h3>
      <div className="flex flex-col gap-4">
        <p className="text-body-sm gap-4 p-6">
          Pharmacist prophylactic prescribing of allergic rhinitis mediation now
          permitted. If patient presents requesting a prescription to initiate prior to
          a known allergen exposure (without presenting with current allergic
          rhinitis), the pharmacist may prescribe enough to initiate treatment for
          allergy exposure.
        </p>
      </div>
    </div>
  );
};

export default GuidelineUpdate;
